import React, { useState } from 'react';

import cx from 'classnames';
import cloneDeep from 'lodash/cloneDeep';
import Modal from 'react-modal';

import ClientContext from 'Customers/components/detailsModal/ClientContext';
import DetailsModal from 'Customers/components/detailsModal/DetailsModal';
import styles from 'Insights/Headcount/Headcount.module.scss';
import { useVisibility } from 'Shared/useVisibility';

import MonthsNav from './components/Navigation/MonthsNav';
import SubscriptionsView from './components/SubscriptionsView/SubscriptionsView';
import { SubscriptionsContextProvider } from './SubscriptionsContext';
import SubscriptionsHeader from './SubscriptionsHeader';
import modalStyles from '../../components/modalStyles';

const addModalStyle = cloneDeep(modalStyles);
addModalStyle.content.width = '640px';
addModalStyle.content.padding = '0';

const Subscriptions = () => {
  const { isOpen: isDetailsModalShown, open: handleShowDetailsModal, close: handleHideDetailsModal } = useVisibility();
  const [selected, setSelected] = useState(undefined);
  return (
    <SubscriptionsContextProvider>
      <ClientContext.Provider value={{ selected, handleShowDetailsModal }}>
        <div className={cx(styles.content, 'm-3', 'position-relative', 'panel', 'radius-4', 'p-0', 'mb-0')}>
          <div className='d-flex flex-column h-100'>
            <div className='mt-2a'>
              <SubscriptionsHeader />
            </div>
            <div className='mt-5'>
              <MonthsNav />
            </div>
            <SubscriptionsView handleShowDetailsModal={handleShowDetailsModal} setSelected={setSelected} />
          </div>
        </div>

        <Modal
          isOpen={isDetailsModalShown}
          shouldCloseOnOverlayClick={false}
          contentLabel='Add Client'
          ariaHideApp={false}
          style={addModalStyle}
          onRequestClose={() => {
            handleHideDetailsModal();
          }}
        >
          <DetailsModal
            customer={selected || {}}
            onClose={() => {
              handleHideDetailsModal();
            }}
          />
        </Modal>
      </ClientContext.Provider>
    </SubscriptionsContextProvider>
  );
};

export default Subscriptions;
